import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import ValueGrid from "./components/ValueGrid";
import CatalogStrip from "./components/CatalogStrip";
import B2BSection from "./components/B2BSection";
import BrandStory from "./components/BrandStory";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import CartDrawer from "./components/CartDrawer";

const Landing = () => (
  <div className="bg-cream text-brown font-sans min-h-screen" data-testid="app-root">
    <div className="grain-overlay" aria-hidden="true" />
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <ValueGrid />
      <CatalogStrip />
      <B2BSection />
      <BrandStory />
      <Testimonials />
    </main>
    <Footer />
    <CartDrawer />
    <WhatsAppFloat />
  </div>
);

export default Landing;
